import { Row, Col, Button } from 'react-bootstrap';
import serviceOne from "../assets/images/service-1.png";
import serviceTwo from "../assets/images/service-2.png";
import serviceThree from "../assets/images/service-3.png";
import serviceFour from "../assets/images/service-4.png";
import serviceFive from "../assets/images/content-production.png";
import serviceSix from "../assets/images/seo.png";
import serviceSeven from "../assets/images/service-7.png";



const CardStacking = () => {
    return (
        <div className="card-stacking-container">
            <div className="card-stack">
                {/* Card 1 */}
                <div className='service-card dark-color sticky-card'>
                    <Row>
                        <Col lg={6}>
                            <div className='content-section'>
                                <span className='service-number'>01</span>
                                <h1 className='service-name'> Performance Marketing</h1>

                                <p className='seervice-desc mt-5'> We make your ad spend work harder than your sales team. Performance Marketing That Actually Performs is our goal!</p>
                                <p className='seervice-desc mb-5'> We plan, execute, test, optimise, and scale across Meta, Google, LinkedIn, YouTube, and more.</p>

                                <Button variant="outline-light" className='mb-1 me-2'>Revenue-driven ad funnels</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Full-funnel strategy </Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Optimization</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Lead generation </Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Acquisition campaigns</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Retargeting </Button>
                                <Button variant="outline-light" className='mb-1 me-2'> Retention flows</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>ROI & ROAS-focused dashboards</Button>
                            </div>

                        </Col>
                        <Col lg={6}>
                            <div className='img-section'>
                                <img src={serviceOne} className='service-img' alt="performance-img" />
                            </div>
                        </Col>
                    </Row>
                </div>
                {/* Card 2 */}
                <div className='service-card theme-color sticky-card'>
                    <Row>
                        <Col lg={6}>
                            <div className='content-section'>
                                <span className='service-number'>02</span>
                                <h1 className='service-name'> Social Media Marketing</h1>

                                <p className='seervice-desc my-5'> We create content built to engage and strategies built to convert.
                                    No fillers. No fluff.
                                </p>

                                <Button variant="outline-light" className='mb-1 me-2'>Monthly content strategy</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Reels, videos, graphics </Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Community management</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Influencer collaborations</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Brand storytelling</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Brand awareness campaigns</Button>
                            </div>

                        </Col>
                        <Col lg={6}>
                            <div className='img-section'>
                                <img src={serviceTwo} className='service-img' alt="performance-img" />
                            </div>
                        </Col>
                    </Row>
                </div>
                {/* Card 3 */}
                <div className='service-card theme-light sticky-card'>
                    <Row>
                        <Col lg={6}>
                            <div className='content-section'>
                                <span className='service-number'>03</span>
                                <h1 className='service-name'> Branding &  <br /> Creative</h1>

                                <p className='seervice-desc my-5'> We give your brand a voice, a visual identity and a vibe that’s unforgettable.</p>

                                <Button variant="outline-light" className='mb-1 me-2'>Brand identity & guidelines</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Reels, videos, graphics </Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Logo design</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Tone of voice creation</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Packaging & collateral</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Creative ad campaigns</Button>
                            </div>

                        </Col>
                        <Col lg={6}>
                            <div className='img-section'>
                                <img src={serviceThree} className='service-img' alt="performance-img" />
                            </div>
                        </Col>
                    </Row>
                </div>
                {/* Card 4 */}
                <div className='service-card theme-light-green sticky-card'>
                    <Row>
                        <Col lg={6}>
                            <div className='content-section'>
                                <span className='service-number'>04</span>
                                <h1 className='service-name'> Web Design & Development</h1>

                                <p className='seervice-desc my-5'> Your digital storefront needs to be fast, functional and conversion-focused.</p>

                                <Button variant="outline-light" className='mb-1 me-2'>UX/UI design</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Website development </Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Landing pages built for ads</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>E-commerce site development</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Full device optimization</Button>
                            </div>

                        </Col>
                        <Col lg={6}>
                            <div className='img-section'>
                                <img src={serviceFour} className='service-img' alt="performance-img" />
                            </div>
                        </Col>
                    </Row>
                </div>
                {/* Card 5 */}
                <div className='service-card theme-purple sticky-card'>
                    <Row>
                        <Col lg={6}>
                            <div className='content-section'>
                                <span className='service-number'>05</span>
                                <h1 className='service-name'> Content <br />Production</h1>

                                <p className='seervice-desc my-5'> High-quality creative assets that work across platforms.</p>

                                <Button variant="outline-light" className='mb-1 me-2'>Photoshoots</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Product videos </Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Ad film creation</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Creative scripting</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Editing & post-production</Button>
                            </div>

                        </Col>
                        <Col lg={6}>
                            <div className='img-section'>
                                <img src={serviceFive} className='service-img' alt="performance-img" />
                            </div>
                        </Col>
                    </Row>
                </div>
                {/* Card 6 */}
                <div className='service-card theme-blue sticky-card'>
                    <Row>
                        <Col lg={6}>
                            <div className='content-section'>
                                <span className='service-number'>06</span>
                                <h1 className='service-name'> Search Engine Optimization</h1>

                                <p className='seervice-desc my-5'> Ranking isn’t luck — it’s strategy.
                                    We help you dominate search results, increase traffic, and convert intent-driven customers.
                                </p>

                                <Button variant="outline-light" className='mb-1 me-2'>Keyword research</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>On-page SEO</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Technical SEO</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Blog optimization</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Backlink building</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>SEO content strategy</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Performance tracking & analytics</Button>
                            </div>

                        </Col>
                        <Col lg={6}>
                            <div className='img-section'>
                                <img src={serviceSix} className='service-img' alt="performance-img" />
                            </div>
                        </Col>
                    </Row>
                </div>
                {/* Card 7 */}
                <div className='service-card theme-green sticky-card'>
                    <Row>
                        <Col lg={6}>
                            <div className='content-section'>
                                <span className='service-number'>07</span>
                                <h1 className='service-name'> WhatsApp <br/> Marketing</h1>

                                <p className='seervice-desc my-5'> Your customers open WhatsApp more than any other app — we leverage that attention.</p>

                                <Button variant="outline-light" className='mb-1 me-2'>Automated WhatsApp workflows</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Broadcast campaigns</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Catalogue marketing</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Lead nurturing</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Chatbot flows</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>WhatsApp API setup</Button>
                                <Button variant="outline-light" className='mb-1 me-2'>Personalized customer journeys</Button>
                            </div>

                        </Col>
                        <Col lg={6}>
                            <div className='img-section'>
                                <img src={serviceSeven} className='service-img' alt="performance-img" />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

        </div>
    );
};

export default CardStacking;
